import { combineReducers } from "redux";
import firebaseReducer from './firebase.reducer'
const rootReducer = combineReducers({
  firebaseReducer
});

export default rootReducer;
